type ResolvedStorageValue<T> = {
  path: string
  value: T
}

const isObjectNotFound = (error: unknown) =>
  typeof error === 'object' &&
  error !== null &&
  'code' in error &&
  (error as { code?: string }).code === 'storage/object-not-found'

export async function resolvePreferredStoragePath<T>(
  paths: readonly [string, string],
  load: (path: string) => Promise<T>,
  hasContent: (value: T) => boolean = () => true,
): Promise<ResolvedStorageValue<T>> {
  let emptyPrimary: ResolvedStorageValue<T> | null = null

  for (const [index, path] of paths.entries()) {
    try {
      const value = await load(path)
      if (hasContent(value) || index === paths.length - 1) {
        return { path, value }
      }
      emptyPrimary = { path, value }
    } catch (error) {
      if (!isObjectNotFound(error)) throw error
    }
  }

  if (emptyPrimary) return emptyPrimary
  throw new Error(`No se encontró ningún objeto en: ${paths.join(', ')}`)
}
